/* GTF: ?first=<product-handle> puts that product in the first grid spot on collection pages.
   ?first=<handle>,<handle>,... puts several up front, in the order given (multi-shirt ads).
   ?first_variant=<variant-id> does the same from a Shopify variant ID, which is what catalog ads
   can fill in per product ({{product.retailer_id}}); /variants/<id> redirects to the product's page.
   Used by ad links so an ad lands on the full collection with its shirts up front.
   Fails silently in every case - the collection page must never break because of this. */
(function () {
  var params = new URLSearchParams(window.location.search);
  var grid = document.getElementById('product-grid');
  if (!grid) return;

  // Match the exact handle (not another product whose handle starts the same way)
  function selFor(handle) {
    return 'a[href$="/products/' + handle + '"], a[href*="/products/' + handle + '?"], a[href*="/products/' + handle + '#"]';
  }

  function neutralize(li) {
    li.classList.remove('scroll-trigger', 'animate--slide-in');
    li.removeAttribute('data-cascade');
    li.removeAttribute('style');
  }

  // Search results draw cards at the search page's image shape (square), the grid at its own
  // (portrait), so give the borrowed card the grid's shape or it sits shorter than its neighbours.
  function matchShape(li) {
    var ref = grid.querySelector('[style*="--ratio-percent"]');
    var m = ref && /--ratio-percent:\s*([^;]+)/.exec(ref.getAttribute('style'));
    if (!m) return;
    var parts = li.querySelectorAll('[style*="--ratio-percent"]');
    for (var j = 0; j < parts.length; j++) parts[j].style.setProperty('--ratio-percent', m[1].trim());
  }

  // Elsewhere in the collection (or not in it at all): borrow its card from search results, which
  // render with the same card snippet (only the image shape differs, see matchShape). The card
  // takes its placeholder's spot, so the order holds whichever borrow finishes first.
  function borrow(handle, placeholder) {
    var sel = selFor(handle);
    fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('no such product'); return r.json(); })
      .then(function (p) {
        var q = '/search?q=' + encodeURIComponent('"' + p.title + '"') + '&type=product';
        return fetch(q).then(function (r) { return r.text(); });
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var a = doc.querySelector('li.grid__item ' + sel.split(', ').join(', li.grid__item '));
        var li = a && a.closest('li.grid__item');
        if (!li) throw new Error('not in search results');
        var clone = document.importNode(li, true);
        neutralize(clone);
        matchShape(clone);
        placeholder.parentNode.replaceChild(clone, placeholder);
      })
      .catch(function () { /* drop the placeholder and leave the rest of the page as it was */
        if (placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
      });
  }

  // Already on this page? Move it up. Otherwise hold its spot with a hidden placeholder.
  function putFirst(handles) {
    var items = grid.querySelectorAll(':scope > li.grid__item');
    var slots = handles.map(function (handle) {
      var sel = selFor(handle);
      for (var i = 0; i < items.length; i++) if (items[i].querySelector(sel)) return items[i];
      var placeholder = document.createElement('li');
      placeholder.className = 'grid__item';
      placeholder.style.display = 'none';
      borrow(handle, placeholder);
      return placeholder;
    });
    for (var k = slots.length - 1; k >= 0; k--) grid.insertBefore(slots[k], grid.firstChild);
  }

  var raw = params.get('first');
  if (raw) {
    var handles = [];
    raw.toLowerCase().split(',').forEach(function (h) {
      h = h.replace(/[^a-z0-9-]/g, '');
      if (h && handles.indexOf(h) < 0 && handles.length < 12) handles.push(h);
    });
    if (handles.length) putFirst(handles);
    return;
  }

  var variant = (params.get('first_variant') || '').replace(/[^0-9]/g, '');
  if (!variant) return;
  fetch('/variants/' + variant)
    .then(function (r) {
      var m = /\/products\/([a-z0-9-]+)/.exec(r.url);
      if (!r.ok || !m) throw new Error('no such variant');
      putFirst([m[1]]);
    })
    .catch(function () { /* leave the collection as it was */ });
})();
